export default {
      id: "https-no-ssl-usage",
      viewBox: "0 0 20 30",
      url: __webpack_public_path__ + "img/icons.svg#https-no-ssl",
      toString: function () {
        return this.url;
      }
    }